import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;

  overflow: hidden;

  &:before {
    content: '';

    position: absolute;
    z-index: -1;
    inset: 0;

    background: #e84e22;

    opacity: 0.9;
  }

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;

    min-height: 300px;
  }

  .content {
    margin: 0 auto;
    padding: 3em 0;
  }

  h1 {
    font-family: 'Montserrat';
    font-size: 5rem;
    color: white;
    font-weight: 700;

    margin-bottom: unset;
  }
`;

export const GradientBackground = styled.div`
  position: absolute;
  bottom: -60px;
  width: 100%;
  height: 140px;
  z-index: -1;
  background: linear-gradient(
    0deg,
    var(--green2c) -100%,
    rgba(255, 255, 255, 1) 70%,
    rgba(255, 255, 255, 1) 80%
  );
`;
